<template>
  <div class="fullwidth about narex">
    <editable-item :page="$route.name" item="text" :loaded="editableLoaded" />
    <div class="bigpad">
      <div class="signin">
        <div>
          <label for="email">{{ $nippets.myarea.email }}</label>
          <input type="email" v-model="email" :placeholder="$nippets.myarea.email" />
        </div>
      </div>
      <div class="button-panel">
        <small-button large v-on:click="sendForgotPass">Reset password</small-button>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from '@aws-amplify/auth'
import EditablePage from '@/mixins/EditablePage.js'
import '@/css/my-area.css'

export default {
  mixins: [EditablePage],
  data () {
    return {
      email: ''
    }
  },
  methods: {
    async sendForgotPass() {
      if(this.$k.validEmail(this.email)) {
        try {
          await Auth.forgotPassword(this.email)
          this.$k.messageBox(this.$nippets.changePassword, this.$nippets.myarea.resetEmailSent )
        }
        catch(err) {
          this.$k.messageBox(this.$nippets.changePassword, err.message )
        }
      }
      else {
        this.$k.messageBox(this.$nippets.changePassword, this.$nippets.invalidEmail)
      }
    }
  }
}
</script>

<style scoped>
.bigpad{
  padding:25px 0;
}
</style>